import React, { Fragment, useEffect, useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AppContext } from "@component/AppProvider";
import parse, { domToReact } from "html-react-parser";
import swal from "sweetalert";
import moment from "moment";

import _API from "@util/api";
import _U from "@util/utilities";
import _DEF from "@config/defines";
import _CK from "@util/cookie";

import Editor from "@component/UI/TMEditor";

import Loading from "@component/UI/Loading";
import { Form } from "../Join/index";

export default () => {
    const navigate = useNavigate();
    const { site, iam } = useContext(AppContext);

    if (!_CK.isLogin()) {
        swal("Please Login first.").then(() => {
            document.location.href = "/";
        });
        return;
    }

    return (
        <Fragment>
            <div className="contents">
                {site?.naviMypage && parse(site?.naviMypage)}

                <div className="right">
                    <div className="contentsTop">
                        <h3>Personal Information</h3>
                        <div className="location">
                            <a href="/" className="home">
                                home
                            </a>
                            <div className="loc_txt">
                                <span>Personal Information</span>
                            </div>
                        </div>
                    </div>
                    <div className="contWrap">
                        <Form pageType="MODIFY" />
                    </div>
                </div>
            </div>
        </Fragment>
    );
};
